import { useState } from 'react';
import { WithBillId } from '@mews-commander/types';
import { lt, useScope } from '@mews/framework';
import { getBill, getBillOwnerId } from '@mews-commander/legacy-entities/src/ducks';
import { Container, DropDownButton, DropdownItem, IconName, Stack, StackItem } from '@optimus-web/core';
import { useCommanderSelector } from '@mews-commander/utils';
import { AssociatedWithInfo, OwnedByInfo } from '../AccountsInfoSection';
import { AssociateBillDialog } from '../../../AssociateBillDialog';
import { ChangeBillOwnerDialog } from '../../../ChangeBillOwnerDialog';
import { ORDER_ITEM_CHECKBOX_DATA_TEST_ID } from '../constants';
import { SelectAllCheckbox } from './SelectAllCheckbox';
import { AddServiceOrderButton } from './AddServiceOrderButton';

export const BillControls = ({ billId }: WithBillId) => {
    const scope = useScope() ?? '';
    const billOwnerId = useCommanderSelector((state) => getBillOwnerId(state, { id: billId }));
    const bill = useCommanderSelector((state) => getBill(state, { id: billId }));
    const [billOwnerDialogOpen, setBillOwnerDialogOpen] = useState(false);
    const [billAssociateDialogOpen, setBillAssociateDialogOpen] = useState(false);

    return (
        <Container padding={['0', '200']}>
            <Stack itemAlignment="center" spacing="200" distribution="space-between">
                <Stack spacing="200">
                    <SelectAllCheckbox billId={billId} data-test-id={ORDER_ITEM_CHECKBOX_DATA_TEST_ID} />
                    <StackItem>
                        <AddServiceOrderButton billId={billId} />
                    </StackItem>
                </Stack>
                {bill ? (
                    <Stack alignment="end" spacing="100">
                        <OwnedByInfo accountId={billOwnerId} />
                        <AssociatedWithInfo bill={bill} />
                        <DropDownButton placement="bottom-end" icon={IconName.Edit} variant="ghost" size="small">
                            <DropdownItem
                                label={lt('BillingChangeOwner')}
                                onClick={() => setBillOwnerDialogOpen(true)}
                            />
                            <DropdownItem
                                label={lt('BillingChangeAssociatedProfile')}
                                onClick={() => setBillAssociateDialogOpen(true)}
                            />
                        </DropDownButton>
                    </Stack>
                ) : null}
            </Stack>
            {bill && (
                <>
                    <ChangeBillOwnerDialog
                        scope={scope}
                        active={billOwnerDialogOpen}
                        bill={bill}
                        closeDialog={() => setBillOwnerDialogOpen(false)}
                    />
                    <AssociateBillDialog
                        scope={scope}
                        active={billAssociateDialogOpen}
                        bill={bill}
                        closeDialog={() => setBillAssociateDialogOpen(false)}
                    />
                </>
            )}
        </Container>
    );
};
